export const GET_LOG_CAJAS_START = 'GET_LOG_CAJAS_START';
export const GET_LOG_CAJAS_ERROR = 'GET_LOG_CAJAS_ERROR';
export const GET_LOG_CAJAS_SUCCESS = 'GET_LOG_CAJAS_SUCCESS';

export const DELETE_LOG_CAJA_START = 'DELETE_LOG_CAJA_START';
export const DELETE_LOG_CAJA_ERROR = 'DELETE_LOG_CAJA_ERROR';
export const DELETE_LOG_CAJA_SUCCESS = 'DELETE_LOG_CAJA_SUCCESS';

export const SET_FILTER_PARAMS = 'SET_FILTER_PARAMS';

export const RESET_LOG_CAJA_STATE = 'RESET_LOG_CAJA_STATE';